/**
 * Typed access to the `xliff` package, which ships no declarations of its own (6.x).
 *
 * The types below cover only the slice xliffToJson() needs. They live in a real module rather than
 * an ambient `.d.ts` on purpose: a `declare module` would only apply to programs that happen to
 * include the declaration file, and the apps reach this library through its barrel, so it would be
 * missing exactly where it is needed.
 */

// @ts-expect-error - no type declarations published for `xliff`.
import { xliff12ToJs as untyped } from 'xliff';

/** A placeholder inside a translation, carried as `<x id="INTERPOLATION"/>` in the XLIFF. */
export type XliffPlaceholder = Record<string, { id?: string } | undefined>;

/** A `<target>` is plain text, or a sequence of text and placeholders. */
export type XliffTarget = string | (string | XliffPlaceholder)[];

export interface XliffUnit {
    source?: XliffTarget;
    target?: XliffTarget;
}

export interface XliffJs {
    resources: Record<string, Record<string, XliffUnit> | undefined>;
}

type Xliff12ToJs = (xliff: string, options?: { captureSpacesBetweenElements?: boolean }) => Promise<XliffJs>;

export const xliff12ToJs: Xliff12ToJs = untyped;
